import type { FeePercents } from './model';

export type FeesBreakdown = {
  rateTotal: number;
  agencyFeeTotal: number;
  payrollFeeTotal: number;
  processingFeeTotal: number;
  feesTotal: number;
  subtotalBeforeProcessing: number;
  total: number;
};

export const bookingFees = {
  apply(rateSubtotal: number, fees: FeePercents): FeesBreakdown {
    const agencyFeeTotal = fees.agency ? rateSubtotal * (fees.agency / 100) : 0;
    const payrollFeeTotal = fees.payroll
      ? (rateSubtotal - agencyFeeTotal) * (fees.payroll / 100)
      : 0;
    const subtotalBeforeProcessing =
      rateSubtotal + agencyFeeTotal + payrollFeeTotal;
    const processingFeeTotal = fees.processing
      ? subtotalBeforeProcessing * (fees.processing / 100)
      : 0;
    const feesTotal = agencyFeeTotal + payrollFeeTotal + processingFeeTotal;
    const total = subtotalBeforeProcessing + processingFeeTotal;

    return {
      rateTotal: rateSubtotal,
      agencyFeeTotal,
      payrollFeeTotal,
      processingFeeTotal,
      feesTotal,
      subtotalBeforeProcessing,
      total
    };
  }
} as const;
